import React, {
  useState,
  useCallback,
  useEffect,
  useMemo
} from 'react';
import { Column } from 'devextreme-react/data-grid';
import { Button } from 'devextreme-react';
import { formatMessage } from 'devextreme/localization';
import HeaderButtonMVP from '../HeaderButtonMVP';
import DataGridMVP from '../DataGridMVP';
import columnDataGrid from './columnDataGrid';
import columnDataGridConsignment from './columnDataGridConsignment';
import columnDataGridRecycling from './columnDataGridRecycling';
import columnDataM15 from './columnDataGridM15';
import columnDataM4 from './columnDataM4';
import columnDataMX1 from './columnDataMX1';
import columnDataGraif from './columnDataGraif';
import columnDataTranspOrder from './columnDataTranspOrder';
import columnDataMKM from './columnDataMKM';
import columnDataProjectNum from './columnDataProjectNum';
import columnDataMX3 from './columnDataMX3';

let searchText = '';
const localTemp = JSON.parse(localStorage.getItem('dataGridQRCode'));
if (localTemp !== null && localTemp.searchText) {
  searchText = localTemp.searchText;
}

const dataSelectTemp = {
  0: {
    listAccept: '',
    itemsAccept: [],
    selectSubmergeItems: [],
    count: 0
  },
  2: {
    listAccept: '',
    listSubmergeItems: [],
    selectSubmergeItems: [],
    count: 0
  },
  5: {
    listAccept: '',
    count: 0
  },
  20: {
    listAccept: '',
    listDeleteItems: [],
    selectDeleteItems: [],
    count: 0
  }
};

let prover = true;

const QRCodeTab = ({
  qrReducer: { listDataQRTab },
  userReducer: {
    permissions,
    id
  },
  modalReducer: { status },
  settingsReducer: { settings },
  tabsReducer: { tabSelect },
  incomingReducer,
  shipmentReducer,
  popupActReducer,
  qrDataList,
  modalPostStockOpen,
  modalPostStockConsignmentOpen,
  modalShipmentSubmergeOpen,
  modalShipmentRedeemConsignmentOpen,
  shippingType,
  plantId,
  modalStatusClear,
  modalErrorOpen,
  modalProcessingStartOpen,
  modalDeletingPieceOpen,
  processingReducer,
  isUseM4,
  showTranspOrder,
  isUseMhOnExpeditor
}) => {
  /** Видимость кнопок - Отгрузка, Отмена отгрузки */
  const [visibleBtn, setVisibleBtn] = useState({
    btnShipping: false,
    btnIncoming: false
  });
  /** Данные */
  const [dataSelect, setDataSelect] = useState(dataSelectTemp);
  /** Данные по таблице */
  const [thisDataGridInstance, setThisDataGridInstance] = useState({});
  /** Фильтры по таблице */
  const [filterDataGrid, setFilterDataGrid] = useState({
    dateFrom: '',
    dateTo: '',
    filter: searchText,
    actual: 1,
    statusId: null,
    plantId
  });
  /** Видимость поля при селекте строчек */
  const [headButtVisibol, setHeadButtVisibol] = useState({ display: 'none' });

  useEffect(() => {
    if (permissions.length) {
      setVisibleBtn({
        btnShipping: permissions.indexOf('btnShipping') !== -1,
        btnIncoming: permissions.indexOf('btnIncoming') !== -1
      });
    }
  }, [permissions]);

  useEffect(() => {
    if (incomingReducer.okRequest) {
      thisDataGridInstance.instance.clearSelection();
    }
    if (shipmentReducer.okRequest) {
      thisDataGridInstance.instance.clearSelection();
    }
  }, [incomingReducer.okRequest, thisDataGridInstance, shipmentReducer.okRequest]);

  /** Запрос на данные */
  useEffect(() => {
    if (status === 2) {
      modalStatusClear();
    }
    if (status === 0) {
      prover = true;
    }
    if (id !== null && prover && tabSelect === 4) {
      prover = false;
      qrDataList({
        ...filterDataGrid,
        plantId
      });
    }
  }, [
    qrDataList,
    filterDataGrid,
    plantId,
    id,
    status,
    modalStatusClear,
    tabSelect
  ]);

  useEffect(() => {
    if (shipmentReducer.okUpdate === true) {
      if (id !== null) {
        qrDataList({
          ...filterDataGrid,
          plantId
        });
      }
    }
  }, [filterDataGrid, qrDataList, id, shipmentReducer.okUpdate, plantId]);

  useEffect(() => {
    if (id !== null && shipmentReducer.okRequest && tabSelect === 3) {
      qrDataList({
        ...filterDataGrid,
        plantId
      });
    }
  }, [qrDataList, filterDataGrid, plantId, shipmentReducer.okRequest, id, tabSelect]);

  useEffect(() => {
    if (id !== null && processingReducer.okRequest && tabSelect === 3) {
      qrDataList({
        ...filterDataGrid,
        plantId
      });
      thisDataGridInstance.instance.clearSelection();
    }
  }, [
    qrDataList,
    filterDataGrid,
    plantId,
    processingReducer.okRequest,
    id,
    tabSelect,
    thisDataGridInstance
  ]);

  useEffect(() => {
    if (id !== null && popupActReducer.okRequest && tabSelect === 3) {
      qrDataList({
        ...filterDataGrid,
        plantId
      });
    }
  }, [qrDataList, filterDataGrid, plantId, popupActReducer.okRequest, id, tabSelect]);

  /** Событие на выделение строк */
  const onSelectionChanged = useCallback(({ selectedRowsData, component }) => {
    const tempDataSelect = JSON.parse(JSON.stringify(dataSelectTemp));
    if (selectedRowsData.length) {
      const rowsToDeselect = [];
      selectedRowsData.forEach((item) => {
        // если рулон в мастере
        if (item.mcNumId) {
          rowsToDeselect.push(item.pieceNumId);
          try {
            modalErrorOpen({
              message: `${formatMessage('textModal').textMPLeft} ${item.mcNum} ${formatMessage('textModal').textMPRight}`,
              techInfo: '',
              types: 'info',
              title: formatMessage('textError').warning
            });
          } catch (e) {
            console.debug('Ошибка при выделении рулона, который в мастер рулоне', e);
          }
        } else {
          switch (item.psStatusNumId) {
            case 0: /* В Пути */
              tempDataSelect[0].count += 1;
              tempDataSelect[0].listAccept += `${item.cgId} ${item.actualPieceId}; `;
              tempDataSelect[0].itemsAccept.push(item.pieceNumId);
              tempDataSelect[0].selectSubmergeItems.push(item);
              break;
            case 2: /* В Наличии */
              tempDataSelect[2].count += 1;
              tempDataSelect[2].listSubmergeItems.push(item.pieceNumId);
              tempDataSelect[2].selectSubmergeItems.push(item);
              break;
            case 5: /* Отгружен */
              tempDataSelect[5].count += 1;
              break;
            case 7: /* Возврат */
              rowsToDeselect.push(item.pieceNumId);
              if (item.returnVehicle) {
                modalErrorOpen({
                  message: `СК № ${item.qcId} был ФИЗИЧЕСКИ возвращён в цех. Свяжитесь с цехом отгрузки`,
                  techInfo: '',
                  types: 'info',
                  title: 'Предупреждение'
                });
              } else {
                modalErrorOpen({
                  message: `На СК № ${item.qcId} был оформлен ЛОГИЧЕСКИЙ возврат в цех. Свяжитесь с цехом отгрузки`,
                  techInfo: '',
                  types: 'info',
                  title: 'Предупреждение'
                });
              }
              break;
            default:
              break;
          } /* удаление из списка отсканированных */
          tempDataSelect[20].count += 1;
          tempDataSelect[20].listDeleteItems.push(item.pieceNumId);
          tempDataSelect[20].selectDeleteItems.push(item);
        }
      });
      if (rowsToDeselect.length) {
        component.deselectRows(rowsToDeselect);
      }
      setHeadButtVisibol({ display: 'flex' });
    } else {
      setHeadButtVisibol({ display: 'none' });
    }
    setDataSelect(tempDataSelect);
  }, [modalErrorOpen]);
  /** Событие на закрыть */
  const closeHeaderButtom = useCallback(() => {
    thisDataGridInstance.instance.clearSelection();
    setHeadButtVisibol({ display: 'none' });
  }, [thisDataGridInstance.instance]);

  const openModalPostStock = useCallback(() => {
    modalPostStockOpen({
      listAccept: dataSelect[0].listAccept,
      itemsAccept: dataSelect[0].itemsAccept,
      plantId
    });
  }, [modalPostStockOpen, dataSelect, plantId]);

  const openModalPostStockConsignment = useCallback(() => {
    modalPostStockConsignmentOpen({
      selectSubmergeItems: dataSelect[0].selectSubmergeItems,
      selectAcceptItems: dataSelect[0].itemsAccept,
      plantId
    });
  }, [modalPostStockConsignmentOpen, dataSelect, plantId]);

  const openModalShipmentSubmerge = useCallback(() => {
    if (dataSelect[2].selectSubmergeItems.length === 1) {
      modalShipmentSubmergeOpen({
        selectSubmergeItems: dataSelect[2].selectSubmergeItems,
        plantId,
        listSubmergeItems: dataSelect[2].listSubmergeItems,
        itemAcceptContainer: dataSelect[2].selectSubmergeItems[0].container,
        itemAcceptPlomba: dataSelect[2].selectSubmergeItems[0].plomba,
        itemAcceptTtn: dataSelect[2].selectSubmergeItems[0].ttn,
        itemAcceptTtnDate: dataSelect[2].selectSubmergeItems[0].ttnDate,
        itemAcceptVehicle: dataSelect[2].selectSubmergeItems[0].vehicleIdOut,
        itemAcceptLoadDate: dataSelect[2].selectSubmergeItems[0].dateLoadInContainer,
        itemAcceptActualShipmentDate: dataSelect[2].selectSubmergeItems[0].actualShippingDate
      });
    }
    if (dataSelect[2].selectSubmergeItems.length > 1) {
      const tempData = dataSelect[2].selectSubmergeItems[0];
      dataSelect[2].selectSubmergeItems.forEach((item) => {
        if (tempData.container !== item.container) {
          tempData.container = '';
        }
        if (tempData.plomba !== item.plomba) {
          tempData.plomba = '';
        }
        if (tempData.ttn !== item.ttn) {
          tempData.ttn = '';
        }
        if (tempData.ttnDate !== item.ttnDate) {
          tempData.ttnDate = '';
        }
        if (tempData.vehicleIdOut !== item.vehicleIdOut) {
          tempData.vehicleIdOut = '';
        }
        if (tempData.dateLoadInContainer !== item.dateLoadInContainer) {
          tempData.dateLoadInContainer = '';
        }
        if (tempData.actualShippingDate !== item.actualShippingDate) {
          tempData.actualShippingDate = '';
        }
      });
      modalShipmentSubmergeOpen({
        selectSubmergeItems: dataSelect[2].selectSubmergeItems,
        plantId,
        listSubmergeItems: dataSelect[2].listSubmergeItems,
        itemAcceptContainer: tempData.container,
        itemAcceptPlomba: tempData.plomba,
        itemAcceptTtn: tempData.ttn,
        itemAcceptTtnDate: tempData.ttnDate,
        itemAcceptVehicle: tempData.vehicleIdOut,
        itemAcceptLoadDate: tempData.dateLoadInContainer,
        itemAcceptActualShipmentDate: tempData.actualShippingDate
      });
    }
  }, [modalShipmentSubmergeOpen, dataSelect, plantId]);

  const openModalShipmentRedeemConsignmentOpen = useCallback(() => {
    modalShipmentRedeemConsignmentOpen({
      plantId,
      selectSubmergeItems: dataSelect[2].selectSubmergeItems,
      listSubmergeItems: dataSelect[2].listSubmergeItems
    });
  }, [modalShipmentRedeemConsignmentOpen, plantId, dataSelect]);

  const openModalShipmentProcessingStartOpen = useCallback(() => {
    modalProcessingStartOpen({
      plantId,
      selectList: dataSelect[2].selectSubmergeItems
    });
  }, [modalProcessingStartOpen, plantId, dataSelect]);

  /** Удаление из списка отсканированных УЕ */
  const deletePiece = useCallback(() => {
    modalDeletingPieceOpen({
      plantId,
      // eslint-disable-next-line max-len
      selectList: listDataQRTab.filter((items) => dataSelect[20].listDeleteItems.includes(items.pieceNumId))
    });
  }, [modalDeletingPieceOpen, listDataQRTab, plantId, dataSelect]);

  /** Поисковая строка */
  const dataGridOnOptionChanged = useCallback(({ value, name }) => {
    if (name === 'searchPanel') {
      setFilterDataGrid({
        ...filterDataGrid,
        filter: value
      });
    }
    prover = true;
    // eslint-disable-next-line
  }, [filterDataGrid]);

  /** Обновление данных */
  const onClickUpdate = useCallback(() => {
    qrDataList({
      ...filterDataGrid,
      plantId
    });
  }, [qrDataList, filterDataGrid, plantId]);

  const Header = useCallback(() => (
    <HeaderButtonMVP headButtVisibol={headButtVisibol}>
      <Button icon={'close'} stylingMode={'text'} onClick={closeHeaderButtom} />
      {(dataSelect[2].count && shippingType === 0 && visibleBtn.btnShipping
        ? (
          <Button text={`Погрузить (${dataSelect[2].count})`}
                  type={'default'}
                  stylingMode={'contained'}
                  onClick={openModalShipmentSubmerge}
          />
        )
        : ''
      )}
      {(dataSelect[2].count && shippingType === 1 && visibleBtn.btnShipping
        ? (
          <Button text={`Выкупить (${dataSelect[2].count})`}
                  type={'default'}
                  stylingMode={'contained'}
                  onClick={openModalShipmentRedeemConsignmentOpen}
          />
        )
        : ''
      )}
      {(dataSelect[2].count && shippingType === 2 && visibleBtn.btnShipping
        ? (
          <Button text={`Переработать (${dataSelect[2].count})`}
                  type={'default'}
                  stylingMode={'contained'}
                  onClick={openModalShipmentProcessingStartOpen}
          />
        )
        : ''
      )}
      {(dataSelect[0].count && shippingType === 0 && visibleBtn.btnIncoming
        ? (
          <Button text={`Разместить на склад (${dataSelect[0].count})`}
                  type={'default'}
                  stylingMode={'contained'}
                  onClick={openModalPostStock}
          />
        )
        : ''
      )}
      {(dataSelect[0].count && (shippingType === 1 || shippingType === 2) && visibleBtn.btnIncoming
        ? (
          <Button text={`Разместить на склад (${dataSelect[0].count})`}
                  type={'default'}
                  stylingMode={'contained'}
                  onClick={openModalPostStockConsignment}
          />
        )
        : ''
      )}
      <Button text={`Удалить из списка (${dataSelect[0].count + dataSelect[2].count + dataSelect[5].count})`}
              type={'default'}
              stylingMode={'contained'}
              onClick={deletePiece}
      />
    </HeaderButtonMVP>
  ), [
    visibleBtn,
    headButtVisibol,
    closeHeaderButtom,
    dataSelect,
    shippingType,
    openModalPostStock,
    openModalPostStockConsignment,
    openModalShipmentSubmerge,
    openModalShipmentRedeemConsignmentOpen,
    openModalShipmentProcessingStartOpen,
    deletePiece
  ]);

  const renderColumnDataGrid = useMemo(() => (
    columnDataGrid.map(
      (item) => (
        <Column dataField={item.dataField}
                caption={formatMessage('textTable')[item.dataField]}
                visible={!item.notVisible}
                allowSearch={false}
                allowFiltering
                cellRender={item.cellRender}
                key={item.dataField}
                dataType={item.dataType}
                cssClass={item.cssClass}
                width={item.width ? item.width : undefined}
        />
      )
    )
  ), []);

  const renderColumnDataGridConsignment = useMemo(() => (
    columnDataGridConsignment.map(
      (item) => (
        <Column dataField={item.dataField}
                caption={formatMessage('textTable').consignment[item.dataField]}
                visible={!item.notVisible}
                allowSearch={false}
                allowFiltering
                cellRender={item.cellRender}
                key={item.dataField}
                dataType={item.dataType}
                cssClass={item.cssClass}
                width={item.width ? item.width : undefined}
        />
      )
    )
  ), []);

  const renderColumnDataM15 = useMemo(() => (
    columnDataM15.map(
      (item) => (
        <Column dataField={item.dataField}
                caption={formatMessage('textTable').consignment[item.dataField]}
                visible={!item.notVisible}
                allowSearch={false}
                allowFiltering
                cellRender={item.cellRender}
                key={item.dataField}
                dataType={item.dataType}
                cssClass={item.cssClass}
                width={item.width ? item.width : undefined}
        />
      )
    )
  ), []);

  const renderColumnDataGridRecycling = useMemo(() => (
    columnDataGridRecycling.map(
      (item) => (
        <Column dataField={item.dataField}
                caption={formatMessage('textTable').consignment[item.dataField]}
                visible={!item.notVisible}
                allowSearch={false}
                allowFiltering
                cellRender={item.cellRender}
                key={item.dataField}
                dataType={item.dataType}
                cssClass={item.cssClass}
                width={item.width ? item.width : undefined}
        />
      )
    )
  ), []);

  const renderColumnDataM4 = useMemo(() => (
    columnDataM4.map(
      (item) => (
        <Column dataField={item.dataField}
                caption={formatMessage('textTable').consignment[item.dataField]}
                visible={!item.notVisible}
                allowSearch={false}
                allowFiltering
                cellRender={item.cellRender}
                key={item.dataField}
                dataType={item.dataType}
                cssClass={item.cssClass}
                width={item.width ? item.width : undefined}
        />
      )
    )
  ), []);

  const renderColumnMX1M4ForExp = useMemo(() => (
    columnDataMX1.filter((item) => item.dataField !== 'mh1DocStatusDescr'
      && item.dataField !== 'departureDate')
      .map(
        (item) => (
          <Column dataField={item.dataField}
                  caption={isUseM4 ? formatMessage('textTable').MX1M4[item.dataField] : formatMessage('textTable').consignment[item.dataField]}
                  visible={!item.notVisible}
                  allowSearch={false}
                  allowFiltering
                  cellRender={item.cellRender}
                  key={item.dataField}
                  dataType={item.dataType}
                  cssClass={item.cssClass}
          />
        )
      )
  ), [isUseM4]);

  const renderColumnMX3 = useMemo(() => (
    columnDataMX3.map(
      (item) => (
        <Column dataField={item.dataField}
                caption={formatMessage('textTable').consignment[item.dataField]}
                visible={!item.notVisible}
                allowSearch={false}
                allowFiltering
                cellRender={item.cellRender}
                key={item.dataField}
                dataType={item.dataType}
                cssClass={item.cssClass}
        />
      )
    )
  ), []);

  const renderColumnDataMX1M4 = useMemo(() => (
    columnDataMX1.filter((item) => item.dataField !== 'cost')
      .map(
        (item) => (
          <Column dataField={item.dataField}
                  caption={isUseM4 ? formatMessage('textTable').MX1M4[item.dataField] : formatMessage('textTable').consignment[item.dataField]}
                  visible={!item.notVisible}
                  allowSearch={false}
                  allowFiltering
                  cellRender={item.cellRender}
                  key={item.dataField}
                  dataType={item.dataType}
                  cssClass={item.cssClass}
                  width={item.width ? item.width : undefined}
          />
        )
      )
  ), [isUseM4]);

  const renderColumnGraif = useMemo(() => (
    columnDataGraif.map(
      (item) => (
        <Column dataField={item.dataField}
                caption={formatMessage('textTable').consignment[item.dataField]}
                visible={!item.notVisible}
                allowSearch={false}
                allowFiltering
                cellRender={item.cellRender}
                key={item.dataField}
                dataType={item.dataType}
                cssClass={item.cssClass}
        />
      )
    )
  ), []);

  const renderColumnTranspOrder = useMemo(() => (
    columnDataTranspOrder.map(
      (item) => (
        <Column dataField={item.dataField}
                caption={formatMessage('textTable')[item.dataField]}
                visible={!item.notVisible}
                allowSearch={false}
                allowFiltering
                cellRender={item.cellRender}
                key={item.dataField}
                dataType={item.dataType}
                cssClass={item.cssClass}
        />
      )
    )
  ), []);

  const renderColumnMKM = useMemo(() => (
    columnDataMKM.map(
      (item) => (
        <Column dataField={item.dataField}
                caption={formatMessage('textTable').consignment[item.dataField]}
                visible={!item.notVisible}
                allowSearch={false}
                allowFiltering
                cellRender={item.cellRender}
                key={item.dataField}
                dataType={item.dataType}
                cssClass={item.cssClass}
        />
      )
    )
  ), []);

  const renderColumnProjectNum = useMemo(() => (
    columnDataProjectNum.map(
      (item) => (
        <Column dataField={item.dataField}
                caption={formatMessage('textTable')[item.dataField]}
                visible={!item.notVisible}
                allowSearch={false}
                allowFiltering
                cellRender={item.cellRender}
                key={item.dataField}
                dataType={item.dataType}
                cssClass={item.cssClass}
        />
      )
    )
  ), []);

  const isGraif = useMemo(
    () => plantId === '6606' || plantId === '6607' || plantId === '7238' || plantId === '7257' || plantId === '7258'
      || plantId === '7259' || plantId === '7260' || plantId === '7261' || plantId === '10003' || plantId === '10004'
      || plantId === '10005',
    [plantId]
  );

  const isMKM = useMemo(
    () => plantId === '8103' || plantId === '8124' || plantId === '8125' || plantId === '8126' || plantId === '8127' || plantId === '8138' || plantId === '8139' || plantId === '8140',
    [plantId]
  );

  const isDipos = useMemo(() => plantId === '8141' || plantId === '8109', [plantId]);

  return (
    <>
      <Header />
      <DataGridMVP dataSource={listDataQRTab}
                   setDataGridInstance={setThisDataGridInstance}
                   onSelectionChanged={onSelectionChanged}
                   filterDataGrid={filterDataGrid}
                   setFilterDataGrid={setFilterDataGrid}
                   className="shipment"
                   setStateStoringName={`dataGridQRCode${shippingType === 1 ? 'Consignment' : (shippingType === 2 ? 'Recycling' : '')}${plantId}`}
                   dataGridOnOptionChanged={dataGridOnOptionChanged}
                   tText={formatMessage('textPeriod')}
                   loadingData={false}
                   visibleButtonQRCode
                   visibleButtonDateRangePicker
                   visibleActyalButton
                   onClickUpdate={onClickUpdate}
                   visibleButtonUpdate
      >
        {(shippingType === 0 ? renderColumnDataGrid : null)}
        {(shippingType === 0 && isUseMhOnExpeditor ? renderColumnMX1M4ForExp : null)}
        {(shippingType === 0 && isUseMhOnExpeditor ? renderColumnMX3 : null)}
        {/* eslint-disable-next-line no-nested-ternary,max-len */}
        {(shippingType === 1 ? (isUseM4 ? renderColumnDataM4 : renderColumnDataGridConsignment) : null)}
        {(shippingType === 1 && isUseM4 ? renderColumnDataMX1M4 : null)}
        {(shippingType === 1 && !isUseM4 && plantId === '7399' ? renderColumnDataM15 : null)}
        {(shippingType === 2 ? renderColumnDataGridRecycling : null)}
        {/* eslint-disable-next-line no-nested-ternary */}
        {(shippingType === 2 ? (isUseM4 ? renderColumnDataMX1M4 : renderColumnDataM15) : null)}
        { isGraif ? renderColumnGraif : null }
        { isMKM || isDipos ? renderColumnMKM : null }
        { showTranspOrder ? renderColumnTranspOrder : null }
        { settings.stockType ? renderColumnProjectNum : null }
      </DataGridMVP>
    </>
  );
};

export default React.memo(QRCodeTab);
